import { render, staticRenderFns } from "./module-permissions.vue?vue&type=template&id=4d4a6252&"
import script from "./module-permissions.vue?vue&type=script&lang=js&"
export * from "./module-permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports